import { render, staticRenderFns } from "./HeroFull.vue?vue&type=template&id=70ec4448&scoped=true&"
import script from "./HeroFull.vue?vue&type=script&lang=js&"
export * from "./HeroFull.vue?vue&type=script&lang=js&"
import style0 from "./HeroFull.vue?vue&type=style&index=0&id=70ec4448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec4448",
  null
  
)

export default component.exports